export default {
  /**
   * Set the List items
   *
   * @param state
   * @param items
   */
  setTeacherArchivedList(state, items) {
    state.items = items;
  },

  /**
   * Set List pagination meta
   *
   * @param state
   * @param pagination
   */
  setTeacherArchivedListPagination(state, pagination) {
    state.pagination = pagination;
  },

  /**
   * Set List current page
   *
   * @param state
   * @param currentPage
   */
  setTeacherArchivedListPage(state, currentPage) {
    state.pagination.current_page = currentPage;
  },

  /**
   *
   * @param state
   * @param filters
   */
  setTeacherArchivedListFilters(state, filters) {
    console.log("Filters : ", filters);

    state.filters = filters;
  },

  /**
   *
   * @param state
   * @param isBusy
   */
  setTeacherArchivedListBusy(state, isBusy) {
    console.log("Busy : ", isBusy);
    state.isBusy = isBusy;
  },
};
